import type { ReactNode } from "react";
import { AppSheet } from "@/modules/shell/AppSheet";

/** Full-screen Floor sheet — Cancel top · title · body scroll (plan/35). */
export function PosFloorSheet(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  children: ReactNode;
  /** Optional trailing header control (same width slot as Cancel). */
  trailing?: ReactNode;
}) {
  return <AppSheet {...props} />;
}
